
import Balance from "./Balance.png";
import Comet from "./Comet.png";
import Donjon from "./Donjon.png";
import Euryale from "./Euryale.png";
import Fates from "./Fates.png";
import Flames from "./Flames.png";
import Fool from "./Fool.png";
import Gem from "./Gem.png";
import Jester from "./Jester.png";
import Key from "./Key.png";
import Knight from "./Knight.png";
import Moon from "./Moon.png";
import Puzzle from "./Puzzle.png";
import Rogue from "./Rogue.png";
import Ruin from "./Ruin.png";
import Sage from "./Sage.png";
import Skull from "./Skull.png";
import Star from "./Star.png";
import Sun from "./Sun.png";
import Talons from "./Talons.png";
import Throne from "./Throne.png";
import Void from "./Void.png";

export const DECK_OF_MANY_THINGS_URLS = [
  Balance, 
  Comet,
  Donjon, 
  Euryale, 
  Fates,
  Flames,
  Fool,
  Gem,
  Jester, 
  Key, 
  Knight, 
  Moon,
  Puzzle,
  Rogue,
  Ruin, 
  Sage,
  Skull, 
  Star,
  Sun,
  Talons,
  Throne,
  Void
];
  